import { type CartellaDto } from '@framework/api-client/api/inquiries-compile/schemas/cartellaDto.ts';
import { type CartelleProcedimentoAreaPubblicaDto } from '@framework/api-client/api/inquiries-compile/schemas/cartelleProcedimentoAreaPubblicaDto.ts';
import { type FileCartellaDto } from '@framework/api-client/api/inquiries-compile/schemas/fileCartellaDto.ts';

export interface IPublicAreaFile extends FileCartellaDto {
  type: 'file';
}

export interface IPublicAreaFolder extends CartellaDto {
  type: 'folder';
  children?: IPublicAreaFile[];
}

export type IPublicAreaItem = IPublicAreaFile | IPublicAreaFolder;

export function getTableTreeDataFromCartelle(
  data?: CartelleProcedimentoAreaPubblicaDto,
): IPublicAreaItem[] {
  return (
    data?.dati?.map(folder => ({
      type: 'folder',
      nome: folder.nome ?? 'N/A',
      id: folder.id + '/folder',
      // altri dati che non sono presenti in una cartella ma uniamo
      // per avere un'unica struttura nella tabella
      tipo: '',
      numeroProtocollo: '',
      dataProtocollo: '',
      dataDocumento: '',
      descrizione: '',
      formato: '',
      dimensione: '',
      url: '',
      // i file passati come children per AntTable
      children: folder.file?.map(file => ({
        type: 'file',
        ...file,
      })),
    })) ?? []
  );
}
